var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHydraulicStrokingUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_3318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 512.602H853.393V634.779L780.204 586.404L673.861 631.677L566.264 586.403L473.058 672.61L372.342 701.14L327.928 664.548L292.897 611.831L259.742 643.462L185.926 582.062L134.63 589.505L77.08 540.509L2.63965 521.904L3.264 512.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 512.602V513.203H852.787V633.655L780.267 585.722L673.859 631.023L566.139 585.697L472.75 672.071L372.483 700.474L328.385 664.142L293.001 610.896L259.714 642.653L186.108 581.428L134.816 588.869L77.3663 539.961L3.27796 521.443L3.86903 512.642L3.26384 512.602V513.203V512.602L2.65865 512.562L2 522.364L76.7934 541.058L134.445 590.14L185.745 582.697L259.769 644.27L292.792 612.767L327.47 664.953L372.201 701.805L473.364 673.148L566.39 587.109L673.861 632.331L780.141 587.085L854 635.903V512H2.69597L2.65865 512.562L3.26384 512.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 512.602V513.203H852.787V633.655L780.267 585.722L673.859 631.023L566.139 585.697L472.75 672.071L372.483 700.474L328.385 664.142L293.001 610.896L259.714 642.653L186.108 581.428L134.816 588.869L77.3663 539.961L3.27796 521.443L3.86903 512.642L3.26384 512.602ZM3.26384 512.602V513.203V512.602ZM3.26384 512.602L2.65865 512.562L2 522.364L76.7934 541.058L134.445 590.14L185.745 582.697L259.769 644.27L292.792 612.767L327.47 664.953L372.201 701.805L473.364 673.148L566.39 587.109L673.861 632.331L780.141 587.085L854 635.903V512H2.69597L2.65865 512.562L3.26384 512.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 382.5H300V496.5H509V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324 382.5H311V496.5H324V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351 382.5H338V496.5H351V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376 382.5H363V496.5H376V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401 382.5H388V496.5H401V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426 382.5H413V496.5H426V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 382.5H439V496.5H452V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479 382.5H466V496.5H479V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504 382.5H491V496.5H504V382.5Z",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.75 523.78H557.22V597.33H584.75V523.78Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.39 597.37L563.33 597.59V630.83L567.9 632.77L568.36 631.97L573.84 632.2L574.41 632.66L578.07 631.06L578.41 630.38L578.74 597.47H584.55V674.6H557.42V597.37H557.39Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.32 597.58H561.99V631.07L570.93 633.43L580.1 630.32V597.56H584.55V674.67H557.37V597.58H557.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.34 529.3V674.66H584.58V524",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.34 529.3V674.66H584.58V524",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.1 534.54V656.59V534.54Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.1 534.54V656.59",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.36 656.37L531.5 659.28L557.34 661.21V656.37H557.36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.36 666.71L531.5 669.61L557.34 671.55V666.7L557.36 666.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.66 666.71L610.5 669.61L584.66 671.55V666.7V666.71Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.66 656.37L610.5 659.28L584.66 661.21V656.37Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.44 513.74H556.07V515.19H557.44V513.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.77 513.74H566.4V515.19H567.77V513.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.69 513.74H574.32V515.19H575.69V513.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.27 513.74H584.9V515.19H586.27V513.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.5 511L555.56 513.73H586.56V511H555.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.43 511.14L586.55 511.2L555.43 511.14Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.43 511.14L586.55 511.2",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.43 513.84H584.6L584.5 524.06L557.4 529.3V513.84H557.43Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.97 528.45V538.45L580.13 534.53V524.88L561.97 528.45Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.56 537.28V564.78L571 559.45L574.21 561.75V535.87L567.56 537.29V537.28Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.99 538.4V656.74V538.4Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M561.99 538.4V656.74",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.77 656.67V652H563.289V574.46H561.979",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.77 656.67V652H563.289V574.46H561.979",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.09 568.68L573.62 571.21V597.53H574.5V604.16H567.5V597.5H568.39V572.24L571.05 568.69L571.09 568.68Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.32 645.57H567.9H563.32Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.32 645.57H567.9",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.24 648.52C574.238 649.155 574.048 649.774 573.694 650.301C573.341 650.827 572.839 651.237 572.252 651.479C571.665 651.72 571.02 651.782 570.398 651.657C569.776 651.532 569.205 651.226 568.757 650.776C568.309 650.327 568.004 649.755 567.881 649.133C567.758 648.51 567.822 647.865 568.066 647.279C568.309 646.693 568.72 646.193 569.248 645.84C569.776 645.488 570.396 645.3 571.03 645.3C571.453 645.3 571.871 645.383 572.261 645.545C572.651 645.707 573.005 645.945 573.304 646.244C573.602 646.543 573.838 646.898 573.999 647.289C574.16 647.679 574.242 648.098 574.24 648.52Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.09 574.48H578.72V652H574.26V656.5",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.09 574.48H578.72V652H574.26V656.5",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 605.25L563.86 608.76V631.06L567.64 632.67",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.86 605.25L563.86 608.76V631.06L567.64 632.67",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.24 605.25L578.24 608.76V631.06L574.47 632.67",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.24 605.25L578.24 608.76V631.06L574.47 632.67",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.22 621.6L578.22 622.92L574.22 621.6Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.22 621.6L578.22 622.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.26 629.88C574.26 630.515 574.072 631.135 573.719 631.663C573.366 632.191 572.865 632.603 572.278 632.846C571.692 633.089 571.046 633.152 570.424 633.028C569.801 632.904 569.229 632.599 568.78 632.15C568.331 631.701 568.025 631.129 567.902 630.506C567.778 629.883 567.841 629.238 568.084 628.652C568.327 628.065 568.739 627.564 569.266 627.211C569.794 626.858 570.415 626.67 571.05 626.67C571.901 626.67 572.718 627.008 573.32 627.61C573.922 628.212 574.26 629.029 574.26 629.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.04 645.57H578.63H574.04Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.04 645.57H578.63",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88 621.6L563.88 622.92L567.88 621.6Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.88 621.6L563.88 622.92",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 500.5H559V510.5H582V500.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518 496.5H290V511.5H518V496.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 373.5H294V382.5H513V373.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436 393.5H379V493.5H436V393.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.5 353.5H440.5C436.358 353.5 433 356.858 433 361C433 365.142 436.358 368.5 440.5 368.5H485.5C489.642 368.5 493 365.142 493 361C493 356.858 489.642 353.5 485.5 353.5Z",
    fill: "#F7F9F9",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452 368.5H449V373.5H452V368.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M476 368.5H473V373.5H476V368.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484 348.5H479V353.5H484V348.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486 347.5H477V350.5H486V347.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423 405.5H392V433.5H423V405.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 434.5H383V455.5H388V434.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 443.5H385V452.5H386V443.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386 438.5H385V439.5H386V438.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583 496.5H558V500.5H583V496.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 483.5H564V496.5H578V483.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 468.5H564V483.5H578V468.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578 55.5H564V458.5H578V55.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558 55.5H557V418.5H558V55.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 384.5H563V391.5H580V384.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 387.5H555V389.5H565V387.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580 163.5H563V170.5H580V163.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 166.5H555V168.5H565V166.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565 470.5H559V474.5H565V470.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.98 456.5H565.02C563.352 456.5 562 457.852 562 459.52V465.48C562 467.148 563.352 468.5 565.02 468.5H576.98C578.648 468.5 580 467.148 580 465.48V459.52C580 457.852 578.648 456.5 576.98 456.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582 502.5H577V506.5H582V502.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526 498.5H497V508.5H526V498.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522 500.5H515V506.5H522V500.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.32 464.97H586.53V468.05H589.32V464.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.33 468.97H579.5V469H589.33V468.97Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.93 465.46C591.559 465.46 594.5 462.519 594.5 458.89C594.5 455.262 591.559 452.32 587.93 452.32C584.302 452.32 581.36 455.262 581.36 458.89C581.36 462.519 584.302 465.46 587.93 465.46Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.96 464.88C591.268 464.88 593.95 462.198 593.95 458.89C593.95 455.582 591.268 452.9 587.96 452.9C584.652 452.9 581.97 455.582 581.97 458.89C581.97 462.198 584.652 464.88 587.96 464.88Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.021 462.51L584.3 461.64L583.021 462.51Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.021 462.51L584.3 461.64",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.38 462.76L591.29 461.93L592.38 462.76Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.38 462.76L591.29 461.93",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.92 458.83H593.84H592.92Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.92 458.83H593.84",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.36 457.22L583.18 457.4L582.36 457.22Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.36 457.22L583.18 457.4",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.25 455.3L583.9 455.93L583.25 455.3Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.25 455.3L583.9 455.93",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.61 453.92L585.13 454.79L584.61 453.92Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.61 453.92L585.13 454.79",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.35 453.16L586.64 454.16L586.35 453.16Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.35 453.16L586.64 454.16",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.24 453V454.07V453Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.24 453V454.07",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.06 453.24L589.63 454.17L590.06 453.24Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.06 453.24L589.63 454.17",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.67 454L591 454.77L591.67 454Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.67 454L591 454.77",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.8 455.51L592.15 455.97L592.8 455.51Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.8 455.51L592.15 455.97",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.63 457.15L592.88 457.46L593.63 457.15Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.63 457.15L592.88 457.46",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.22 460.35L582.35 460.72L583.22 460.35Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.22 460.35L582.35 460.72",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 458.71L590.33 455.02L588 458.71Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588 458.71L590.33 455.02",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M587.99 459.77C588.459 459.77 588.84 459.39 588.84 458.92C588.84 458.451 588.459 458.07 587.99 458.07C587.52 458.07 587.14 458.451 587.14 458.92C587.14 459.39 587.52 459.77 587.99 459.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 460.52L593.46 460.83L592.71 460.52Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M592.71 460.52L593.46 460.83",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.18 458.85H582.97H582.18Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.18 458.85H582.97",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 482.5C509 482.5 558.5 482.5 557.5 418.5",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509 487.75C509 487.75 519 489.57 533.5 480.53C548 471.49 559 472.53 559 472.53",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312 498.5H283V508.5H312V498.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293 500.5H286V506.5H293V500.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.42 406.35H330.15V409.04H345.42V406.35Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.76 450.07C344.27 455.02 350.51 454.86 352.23 450.18L353.04 447.06",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.76 450.07C344.27 455.02 350.51 454.86 352.23 450.18L353.04 447.06",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.34 446.9H330.23V449.37H345.34V446.9Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.49 408.51H320.25V447.34H356.49V408.51Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.89 410.98H321.87V444.86H354.89V410.98Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.31 438.83C329.31 439.301 329.17 439.761 328.909 440.152C328.647 440.544 328.275 440.849 327.841 441.029C327.406 441.209 326.927 441.256 326.466 441.164C326.004 441.072 325.58 440.846 325.247 440.513C324.914 440.18 324.687 439.756 324.596 439.294C324.504 438.833 324.551 438.354 324.731 437.919C324.911 437.484 325.216 437.113 325.608 436.851C325.999 436.59 326.459 436.45 326.93 436.45C327.561 436.45 328.166 436.701 328.613 437.147C329.059 437.593 329.31 438.199 329.31 438.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91 438.83C337.91 439.301 337.771 439.761 337.509 440.152C337.248 440.544 336.876 440.849 336.441 441.029C336.006 441.209 335.528 441.256 335.066 441.164C334.604 441.072 334.18 440.846 333.847 440.513C333.515 440.18 333.288 439.756 333.196 439.294C333.104 438.833 333.151 438.354 333.332 437.919C333.512 437.484 333.817 437.113 334.208 436.851C334.6 436.59 335.06 436.45 335.53 436.45C336.162 436.45 336.767 436.701 337.213 437.147C337.66 437.593 337.91 438.199 337.91 438.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.5 438.83C346.5 439.301 346.361 439.761 346.099 440.152C345.838 440.544 345.466 440.849 345.031 441.029C344.596 441.209 344.118 441.256 343.656 441.164C343.194 441.072 342.77 440.846 342.437 440.513C342.104 440.18 341.878 439.756 341.786 439.294C341.694 438.833 341.741 438.354 341.921 437.919C342.102 437.484 342.407 437.113 342.798 436.851C343.189 436.59 343.65 436.45 344.12 436.45C344.751 436.45 345.357 436.701 345.803 437.147C346.249 437.593 346.5 438.199 346.5 438.83Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.81 413.56H353.5C353.613 413.56 353.725 413.582 353.829 413.626C353.934 413.669 354.028 413.732 354.108 413.812C354.188 413.892 354.251 413.987 354.295 414.091C354.338 414.195 354.36 414.307 354.36 414.42V432.06C354.358 432.287 354.266 432.505 354.105 432.665C353.945 432.826 353.727 432.917 353.5 432.92H323.81C323.583 432.917 323.366 432.826 323.205 432.665C323.044 432.505 322.953 432.287 322.95 432.06V414.42C322.95 414.192 323.041 413.973 323.202 413.812C323.363 413.651 323.582 413.56 323.81 413.56Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.17 415.6H324.34V431.3H353.17V415.6Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.71 349.1H336.24V373H339.71V349.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.74 344.24H339.74C340.16 344.243 340.562 344.411 340.858 344.709C341.154 345.007 341.32 345.41 341.32 345.83V347.91C341.32 348.329 341.154 348.731 340.857 349.027C340.561 349.324 340.159 349.49 339.74 349.49H336.74C336.321 349.49 335.919 349.324 335.623 349.027C335.327 348.731 335.16 348.329 335.16 347.91V345.83C335.16 345.41 335.326 345.007 335.622 344.709C335.918 344.411 336.32 344.243 336.74 344.24Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.15 346.52H316.91",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.97 337V355.64",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4 338.64V354.11",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.79 340.65V352.2",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.26 343.05V350.66",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.89 344.64V348.38",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.08 345.43V347.72",
    stroke: "#F7F9F9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.79 41.5H567.21C564.885 41.5 563 43.3849 563 45.71V51.29C563 53.6151 564.885 55.5 567.21 55.5H573.79C576.115 55.5 578 53.6151 578 51.29V45.71C578 43.3849 576.115 41.5 573.79 41.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.7 37.5H569.3C568.582 37.5 568 38.082 568 38.8V40.2C568 40.918 568.582 41.5 569.3 41.5H571.7C572.418 41.5 573 40.918 573 40.2V38.8C573 38.082 572.418 37.5 571.7 37.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.31 45.5C563.31 45.5 556.89 44.65 557.5 56",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_3318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHydraulicStrokingUnit);
export default __webpack_public_path__ + "static/media/hydraulic-stroking-unit.77771185ea7026652928b725dd264d59.svg";
export { ForwardRef as ReactComponent };